import { paths } from "../../config/paths";
import { LandingPage } from "../../features/landing-page/LandingPage";
import { useTranslation } from "../../lib/i18n";

export const BeautyProfilerHome = () => {
  const { t } = useTranslation();

  return (
    <LandingPage
      backgroundPath="/beauty-profiler/landing-page.webm"
      subtitle={t('landing.beautyProfiler.subtitle')}
      title={t('landing.beautyProfiler.title')}
      description={t('landing.beautyProfiler.description')}
      path={paths.beautyProfiler.profiler.path}
    />
  );
};
